/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsAdminShiftCreateInput } from "../../entities/models/AdminShiftCreateInput";
import { z } from "zod/v4";

export const modelsAdminShiftCreateInputSchema = z.object({
    "barber_id": z.int(),
"end_time": z.string(),
"start_time": z.string(),
"station_id": z.int()
    }) as unknown as z.ZodType<ModelsAdminShiftCreateInput>